/**
 * Created by Arif Topcu in 2019
 */

import ComplicationSelector from "@ls/grouping-complication-selector";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDefinition } from "state/bookAnalytics/actions";
import BookAnalyticDefinition from "state/bookAnalytics/BookAnalyticDefinition";
import { selectDefinitions } from "state/bookAnalytics/selectors";
import SelectionState from "state/selections/SelectionState";
import ComplicationComponent from "./BookAnalyticsSelectorComplication";

const BookAnalyticsSelector = (props) => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinitionCallback = useCallback(
    (idx, definition) => dispatch(setDefinition(idx, definition)),
    [dispatch]
  );
  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinitionCallback}
      getDefaultDefinition={BookAnalyticDefinition.getDefault}
      ComplicationComponent={ComplicationComponent}
      btnTitle="Book Analytics"
      addMoreText="Book Analytic Column"
    />
  );
};

export default BookAnalyticsSelector;
